const root = 'https://s.salebot.pro//'

export const config = {
  urls: {
    tg: {
      bill: `${root}84268573bf57f1f59fcc3a3ff71c1870_1`,
      support: `${root}923a6aae8e4e3d58f6986bc65f621d40_1`,
    },
    max: {
      bill: `${root}84268573bf57f1f59fcc3a3ff71c1870_20`,
      support: `${root}923a6aae8e4e3d58f6986bc65f621d40_20`,
    },
  },
}
